import React from 'react';

import { AgentCard } from '../components/AgentCard';
import { AGENTS } from '../lib/agents';
import { useAuth } from '../providers/AuthProvider';

/**
 * Agent Hub page — grid of all 7 agents with full-size cards.
 * Authenticated users also see a "Recent Sessions" section below.
 */
export function AgentHubPage(): React.JSX.Element {
  const { isAuthenticated } = useAuth();

  return (
    <div className="px-4 py-10 sm:px-6 sm:py-14 lg:px-8">
      <div className="mx-auto max-w-6xl">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-2xl font-bold text-text-primary sm:text-3xl">Meet the Agents</h1>
          <p className="mt-1 text-sm font-medium text-text-muted italic">Collaborate with seven AI partners built to make your work better.</p>
          <p className="mt-2 text-text-secondary">
            Begin with the agent that meets you where you are. They&rsquo;ll share their distinct perspective on your strengths and the strengths within your work situation that you can build on. For a complete picture, explore your work situation from the distinct lenses of all seven AAI agents.
          </p>
        </div>

        {/* Agent grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {AGENTS.map((agent) => (
            <AgentCard
              key={agent.id}
              agent={agent}
              size="full"
              ctaLabel="Start a Conversation"
            />
          ))}
        </div>

        {/* Recent Sessions section (authenticated users only) */}
        {isAuthenticated && (
          <section className="mt-14">
            <h2 className="mb-4 text-xl font-semibold text-text-primary">Recent Sessions</h2>
            <div className="rounded-lg border border-border bg-surface-raised p-6 text-center">
              <p className="text-sm text-text-muted">
                Your recent conversations will appear here once you start a session.
              </p>
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
